module["exports"] = [
  "########",
  "## ## ## ##",
  "### ## ###",
  "+47 ## ## ## ##"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nb_NO/phone_number/formats.js
 ** module id = 777
 ** module chunks = 0
 **/